export const KIOSK_SEARCH_PATIENT = "/kiosk/search-patient";
export const KIOSK_PATIENT_DATA = "/kiosk/patient-data";
export const KIOSK_ADD_INSURANCE = "/kiosk/add-insurance";
export const KIOSK_MAKE_PAYMENT = "/kiosk/make-payment";
